const STORAGE_KEY = "failed-renewal-modal";

export function useHideFailedRenewalModal() {
  const isHidden =
    typeof window !== "undefined" &&
    window.sessionStorage.getItem(STORAGE_KEY) !== null;

  function hideModal(reason: string) {
    window.sessionStorage.setItem(STORAGE_KEY, reason);
  }

  return { isHidden, hideModal };
}
